module.exports = __webpack_public_path__ + "static/media/assets.5e6db5d0.svg";